import explanationMessages from '../../data/explanationMessages.json';

const fetchExplanationMatchingCode = (code) => {
  const matchingMessage = explanationMessages.find((explanationMessage) => explanationMessage.code === code);
  return matchingMessage ? matchingMessage.description : '';
};

export default fetchExplanationMatchingCode;
